<template>
    <div>
        <loading v-if="showLoading"></loading>
        <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
        <account-status :account_status="account_status"></account-status>



        <div class="widget has-shadow">

            <div class="widget-header bordered  d-flex align-items-center">
                <h2>مدیریت پیام ها</h2>
                <b-dropdown id="dropdown-1" text="گزینه ها" variant="btn">
                    <b-dd-item to='/messages/add'>
                        <span class="fa fa-pencil"></span>
                        <span>افزودن پیام جدید</span>
                    </b-dd-item>
                </b-dropdown>
            </div>

            <div class="widget-body">

                <div v-if="show_alert_message" style="margin-bottom:10px" class="alert alert-success alert-dismissible fade show" role="alert">
                   <span>{{ alert_message }}</span>
                   <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                      <span aria-hidden="true"></span>
                   </button>
                </div>

                <div class="product_search_div">  
                    <form method="get" class="search_form package_search_box">
                        <input type="text" class="form-control" v-model="search_text" placeholder="عنوان پیام">
                        <a class="btn btn-primary" v-on:click="getMessageList(1)" style="color:white">جست و جو</a>
                    </form>
                </div>
            

                <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>ردیف</th>
                        <th>عنوان</th>
                        <th>ارسال کننده</th>
                        <th>دریافت کننده</th>
                        <th>زمان ارسال</th>
                        <th>عملیات</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(message,key) in messageList.data" :key="message.id">
                           <td>{{ getRow(key) }}</td>
                           <td>{{ message.title }}</td> 
                           <td>
                               <span v-if="message.from!=null">
                                   <span v-if="message.from_type=='App\\User'" class="form_link">
                                      {{ $siteName }}
                                   </span>
                                   <span v-else class="form_link">
                                       {{ message.from.brand_name }}
                                   </span>
                               </span>
                               <span v-else class="form_link"> {{ $siteName }}</span>
                           </td>
                            <td>
                              <span v-if="message.to!=null">
                                   <span v-if="message.to_type=='App\\User'" class="to_link">
                                       {{ $siteName }}
                                   </span>
                                   <span v-else class="to_link">
                                       {{ message.to.brand_name }}
                                   </span>
                               </span>
                               <span v-else class="to_link"> {{ $siteName }}</span>
                            </td>
                            <td>
                               {{ getTime(message.time)}} - {{ getDate(message.time,true)}}
                            </td>
                            <td>
                                <span :class="[ message.status==-1 ? 'fa fa-eye red' : 'fa fa-eye']"  v-on:click="$router.push({name:'MessageContent',params:{id:message.id}})"></span>
                            </td>
                        </tr>
                        <tr v-if="messageList.data.length==0">
                            <td colspan="6">رکوردی یافت نشد</td>
                        </tr>
                    </tbody>
                </table>

                <pagination :data="messageList" @pagination-change-page="getMessageList"></pagination>

            </div>
        </div>
       <server-error-message v-if="server_error"></server-error-message>  

    </div>
</template>

<script>
import myMinix from '../myMixin';
export default {
    mixins:[myMinix],
    data()
    {
        return {
            show_product_list:false,
            server_error:false,
            showLoading:true,
            messageList:{data:[]},
            BreadcrumbList:[
                { path:'/messages',title:'مدیریت پیام ها' },
            ],
            page:1,
            account_status:'active',
            show_alert_message:false,
            alert_message:'',
            search_text:''
        }
    },
    mounted(){
        this.seller_id=localStorage.getItem('seller_id');
        if(this.$route.params.success=='ok')
        {
            this.show_alert_message=true;
            this.alert_message='پیام شما با موفقیت ثبت شد';
        }
        this.account_status=localStorage.getItem('account_status');
        this.$emit('setSideBarItem','messages');
        this.getMessageList();
    },
    methods:{
        getMessageList:function(page=1)
        {
            this.showLoading=true;
            this.page=page;
            const url=this.$siteUrl+'/api/seller/messages/list?page='+page+'&title='+this.search_text;
            this.axios.get(url,this.setHeader()).then(response=>{
                this.showLoading=false;
                const result=this.setAccountStatus(response.data);
                if(result)
                {
                    this.messageList=response.data;
                }
                
            }).catch((error)=>{
                this.setCatch(error);
            });
        },

    }
}
</script>

<style>

</style>